export default [
  {
    path: '/schedule',
    name: 'my_schedule',
    component: () =>
      import(
        /* webpackChunkName: 'my-schedule' */
        '@/views/my-schedule/ScheduleView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/schedule/calendar',
    name: 'my_calendar',
    component: () =>
      import(
        /* webpackChunkName: 'my-schedule' */
        '@/views/my-schedule/CalendarView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/schedule/classes/:type/:id',
    name: 'my_schedule.class_detail',
    component: () =>
      import(
        /* webpackChunkName: 'class-detail' */
        '@/views/classes/ClassDetailView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
];
